import { DateTime } from 'luxon';

import { gatewayApiAgent } from 'common/api/apiAgents';
import {
  PurchaseOrderExtended,
  VendorSimplifiedFilter,
  VendorsSimplified,
} from 'common/api-types/vendor';
import {
  ListMetaWoltGoodsReceipts,
  WoltGoodsReceiptCreateRequest,
  WoltInboundLoad,
  WoltInboundLoads,
} from 'common/api-types/warehouse';

import { FetchGoodsReceiptsParams } from './types';

export const createGoodsReceipt = (
  warehouseId: string,
  itemId: string,
  data: WoltGoodsReceiptCreateRequest,
) => {
  return gatewayApiAgent.post<void>(
    `/warehouse/public/v1/wolt/warehouses/${warehouseId}/items/${itemId}/goods-receipts`,
    data,
  );
};

export const fetchGoodsReceipts = (
  warehouseId: string,
  params: FetchGoodsReceiptsParams,
): Promise<ListMetaWoltGoodsReceipts> =>
  gatewayApiAgent
    .get(`/warehouse/public/v1/wolt/warehouses/${warehouseId}/goods-receipts`, { params })
    .then((res) => res.data);

export const fetchInboundLoads = (
  warehouseId: string,
  searchQuery: string,
): Promise<WoltInboundLoads> => {
  return gatewayApiAgent
    .get(`/warehouse/public/v1/wolt/warehouses/${warehouseId}/inbound-loads`, {
      params: {
        filterItemsQuery: searchQuery ? searchQuery : undefined,
        from: DateTime.now().minus({ days: 7 }).toISODate(),
        to: DateTime.now().plus({ days: 7 }).toISODate(),
        sortBy: 'DELIVERY_DATE',
        highlightedDate: DateTime.now().toISODate(),
      },
    })
    .then((res) => res.data);
};

export const fetchInboundLoad = (
  warehouseId: string,
  inboundLoadId: string,
): Promise<WoltInboundLoad> => {
  return gatewayApiAgent
    .get(`/warehouse/public/v1/wolt/warehouses/${warehouseId}/inbound-loads/${inboundLoadId}`)
    .then((res) => res.data);
};

export const fetchVendors = async (filters: VendorSimplifiedFilter) => {
  const response = await gatewayApiAgent.post<VendorsSimplified>(
    '/vendor/public/v1/vendors/simplified',
    filters,
  );
  return response.data;
};

export const fetchPurchaseOrder = async (inboundLoadId: string) => {
  return gatewayApiAgent
    .get<PurchaseOrderExtended>(`/vendor/public/v1/purchase-orders/${inboundLoadId}`)
    .then((res) => res.data);
};
